import WarningBar from './WarningBar';

export default WarningBar;
